import ProductCardProfile from "../../../../components/ProductCardProfile";

const BasketItems = ({ purchasesProducts, setPurchasesProducts, onRefresh }: { purchasesProducts: any, setPurchasesProducts: any, onRefresh?: any }) => {
    const handleRemoveProduct = async (productId) => {
        setPurchasesProducts(purchasesProducts.filter(product => product._id !== productId));
    };

    if (!purchasesProducts.length) return null;

    return (
        <section className="bk-section">
            <h4 className="bk-section-title">Товари до видачі <span className="bk-count">{purchasesProducts.length}</span></h4>
            <div className="bk-grid">
                { purchasesProducts.map((product) =>
                    <ProductCardProfile
                        key={product._id}
                        data={product}
                        onRemove={() => handleRemoveProduct(product._id)}
                        onRefresh={onRefresh}
                    />
                )}
            </div>
        </section>
    );
};

export default BasketItems;
